<template>
  <div
    class="mt-auto pt-8 border-t border-white/10 flex justify-between items-end"
    :class="[textColorClass, wrapperClass]"
  >
    <div>
      <p v-if="label" :class="labelClass">{{ label }}</p>
      <p v-if="value" :class="valueClass">{{ value }}</p>
    </div>
    <i v-if="iconClass" :class="iconClass" class="text-lg block"></i>
    <slot v-else name="icon" />
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, default: '' },
  value: { type: String, default: '' },
  iconClass: { type: String, default: 'pr pr-import-564564' },
  textColorClass: { type: String, default: 'text-white/30' },
  labelClass: { type: String, default: 'text-[9px] font-bold uppercase tracking-widest' },
  valueClass: { type: String, default: 'text-[10px] font-mono mt-0.5' },
  wrapperClass: { type: String, default: '' }
});
</script>
